import { render, staticRenderFns } from "./marketDetail.vue?vue&type=template&id=5ac8132d&scoped=true"
import script from "./marketDetail.vue?vue&type=script&lang=js"
export * from "./marketDetail.vue?vue&type=script&lang=js"
import style0 from "./marketDetail.vue?vue&type=style&index=0&id=5ac8132d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac8132d",
  null
  
)

export default component.exports